import React from "react";
import { IngestionJob } from "../../api/ingestionJob";
import { AddCustomerReferenceDataStep } from "./add-customer-reference-data-step";
import { ConfirmCustomerReferenceDataStep } from "./confirm-customer-reference-data-step";
import { InblockedCustomerReferenceDataStep } from "./inblocked-customer-reference-data-step";

export const CustomerReferenceDataWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {

    const isAddCustomerReferenceDataStepEnabled = () => {
        if (isEdit) return false;
        return workflowStep === 1;
    }

    const isConfirmCustomerReferenceDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;
        return workflowStep === 2;
    }

    const isInblockedCustomerReferenceDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;
        return workflowStep === 3;
    }

    return <>
        {isAddCustomerReferenceDataStepEnabled() && <AddCustomerReferenceDataStep job={job} next={next} back={back} cancel={cancel} />}
        {isConfirmCustomerReferenceDataStepEnabled() && <ConfirmCustomerReferenceDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
        {isInblockedCustomerReferenceDataStepEnabled() && <InblockedCustomerReferenceDataStep job={job} back={back} $refreshEvents={$refreshEvents} />}
    </>
}